<template>
  <div class="root">
    <div>
      <img
        src="@/assets/images/feedback-header.svg"
        alt="background"
        width="100%"
      />
      <img
        src="@/assets/images/flourish-logotipo.png"
        alt="flourish logotipo"
        width="100"
        height="40"
        class="flourish-logotipo"
      />
    </div>
    <!-- <FontAwesomeIcon
      :icon="faTimes"
      class="close-button"
      @click="navigateToFlourishApp()"
    /> -->
    <div class="content">
      <PlayerStats
        :playerName="playerName"
        :correctAnswers="correctAnswers"
        :reward="coinsBalance"
        :timeToFinishInMilliseconds="timeToFinishInMilliseconds"
        :questionsAmount="loadedQuestions.length"
        style="margin: 1rem;"
      />
      <QuestionsResult :questions="loadedQuestions" />
      <footer class="card">
        <h2 class="call-to-action-message">
          <span>You have completed the challenge!</span><br />
          <span class="call-to-action-message--small"
            >Come back next week!</span
          >
        </h2>
        <div style="padding: 0 1rem;">
          <button
            @click="clickButtonNavigateToFlourishAppBehavior"
            class="confirm footer lighter"
          >
            Back to Flourish app
          </button>
        </div>
      </footer>
    </div>
    <Popup
      v-if="showPopup"
      @closeModal="navigateToFlourishApp(false, 'redirect-to-savings')"
    />
    <ErrorAlert v-show="showErrorAlert" @close-alert="closeErrorAlert()" />
  </div>
</template>

<script>
import PlayerStats from "../components/PlayerStats";
import QuestionsResult from "../components/QuestionsResult";
import Popup from "../components/FeedbackModal";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { mapActions, mapState } from "vuex";
import dayjs from "dayjs";
import ErrorAlert from "../components/ErrorAlert.vue";

export default {
  components: {
    PlayerStats,
    QuestionsResult,
    Popup,
    ErrorAlert,
  },
  data() {
    return {
      faTimes,
      //doOversUsed: 3,
      //fakeQuestions,
      showPopup: false,
      showErrorAlert: false,
      errorAlertInterval: null,
    };
  },
  computed: {
    ...mapState([
      "questions",
      "coinsBalance",
      "startDate",
      "endDate",
      "playerName",
    ]),
    loadedQuestions() {
      if (!this.$store.state.alreadyPlay) {
        let eventName = process.env.VUE_APP_ANALYTICS_EVENT_BASE + "GameFinished";
        this.$logEvent(eventName, {
          coinsEarned: this.coinsBalance,
          timeToFinishInMilliseconds: this.timeToFinishInMilliseconds,
        });
      } else {
        let eventName = process.env.VUE_APP_ANALYTICS_EVENT_BASE + "CheckingScore";
        this.$logEvent(eventName);
      }
      return this.questions;
    },
    correctAnswers() {
      return this.questions.filter((item) => {
        return item.answerStatus === "CORRECT";
      }).length;
    },
    timeToFinishInMilliseconds() {
      let start = this.startDate ? dayjs(this.startDate) : dayjs();
      let end = this.endDate ? dayjs(this.endDate) : dayjs().add(20, "seconds");
      return end.diff(start);
    },
  },
  methods: {
    ...mapActions(["closeGame"]),
    clickButtonNavigateToFlourishAppBehavior() {
      const alreadyPlay = this.$store.state.alreadyPlay;
      if (alreadyPlay) {
        this.navigateToFlourishApp(false, "no-redirect");
      } else {
        this.showPopup = true;
      }
    },
    navigateToFlourishApp(hadErrors, redirectRule) {
      if (hadErrors) {
        this.openErrorAlert();
      }
      this.showPopup = hadErrors;
      this.closeGame(redirectRule);
    },
    closeErrorAlert() {
      this.showErrorAlert = false;
      if (this.errorAlertInterval) {
        clearInterval(this.errorAlertInterval);
      }
    },
    openErrorAlert() {
      this.showErrorAlert = true;
      this.errorAlertInterval = setInterval(() => {
        this.showErrorAlert = false;
        clearInterval(this.errorAlertInterval);
        this.errorAlertInterval = null;
      }, 4000);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/variables.scss";
@import "../scss/common.scss";

@media only screen and (min-width: 600px) {
  .root {
    max-width: 375px;
  }
}

.root {
  min-width: 320px;
  min-height: 570px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  background: $quaternary-darker;
}

.flourish-logotipo {
  position: absolute;
  top: 1rem;
  left: 0;
  right: 0;
  margin: 0 auto;
}

.close-button {
  position: absolute;
  top: 1.5rem;
  right: 0.5rem;
  color: white;
}

.content {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
}

.call-to-action-message {
  font-family: $primary-font;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  text-align: center;
  color: $primary;
  margin-block-start: 0;
  margin-inline-start: 0;
  margin-block-end: 0;
  margin-inline-end: 0;
}

.call-to-action-message--small {
  font-weight: 400;
  font-size: 14px;
}

.card {
  background: $quaternary-darker;
  border: 0.25px solid #a3a3a3;
  box-sizing: border-box;
  box-shadow: 0px 37.4993px 97.0944px rgba(0, 0, 0, 0.0413989);
  border-radius: 10px;
  padding: 1rem 0.5rem;
  margin: 1rem;
}
</style>
